import { load_image_from } from '../../../../helpers/interface_helpers';

export function findImage(device): { image: any; backgroundColor: any } {
	let image = device?.image;

	return {
		image: image ? load_image_from(image, device?.server) : undefined,
		backgroundColor: device?.backgroundColor || undefined,
	};
}

export function findSceneImage(scene): any {
	let image = scene?._meta?.image;

	return {
		image: image ? load_image_from(image) : undefined,
		backgroundColor: scene?._meta?.backgroundColor || undefined,
	};
}
